import { render, staticRenderFns } from "./jibingchufang.vue?vue&type=template&id=7b509676&"
import script from "./jibingchufang.vue?vue&type=script&lang=ts&"
export * from "./jibingchufang.vue?vue&type=script&lang=ts&"
import style0 from "./jibingchufang.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports